var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkRead = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zm2.157-11.207a1 1 0 011.414 0l.707.707a1 1 0 010 1.414l-3.53 3.531-.005.005-.708.707a1 1 0 01-1.414 0L3.793 8.328a1 1 0 010-1.414l.707-.707a1 1 0 011.414 0l1.414 1.414 2.829-2.828z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkRead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarkRead.25daf60dfe501cef7c685d6d1af58262.svg";